/**
 * Quando cambio tab il meta title cambia
 */
export default () => {
    function changeTabTitle(newTitle) {
        document.title = newTitle;
    }

    const originalTitle = document.title;

    document.addEventListener("visibilitychange", function() {
        if (document.hidden) {
            changeTabTitle("👋 Hey siamo qui!");
        } else {
            changeTabTitle(originalTitle);
        }
    });
};
